import { Separator } from "@/components/ui/separator"
import { FormInputField } from "@/components/ui/form-input-field"
import { FormSelectField } from "@/components/ui/form-select-field"

import type { ProductFieldGroupProps, ProductFormOption } from "./product-field-types"

interface ProductInventoryFieldsProps extends ProductFieldGroupProps {
  warehouseOptions: ProductFormOption[]
  weightUnit: string
}

export function ProductInventoryFields({
  control,
  labels,
  warehouseOptions,
  weightUnit,
}: ProductInventoryFieldsProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <span className="text-sm font-black uppercase tracking-widest text-muted-foreground/60">
          {labels.inventoryLogisticsLabel}
        </span>
        <Separator className="flex-1" />
      </div>

      <div className="grid grid-cols-1 items-start gap-6 sm:grid-cols-2 lg:grid-cols-5">
        <FormInputField
          control={control}
          name="initialStock"
          label={labels.stock + " *"}
          type="number"
          placeholder="0"
          labelClassName="min-h-[40px] flex items-end pb-2"
        />
        <FormSelectField
          control={control}
          name="warehouseId"
          label={labels.originWarehouse}
          options={warehouseOptions}
          placeholder={labels.selectWarehouse}
          className="sm:col-span-1 lg:col-span-2"
          labelClassName="min-h-[40px] flex items-end pb-2"
        />
        <FormInputField
          control={control}
          name="lowStockThreshold"
          label={labels.lowStock}
          placeholder="5"
          type="number"
          description={labels.lowStockDesc}
          labelClassName="min-h-[40px] flex items-end pb-2"
        />
        <FormInputField
          control={control}
          name="leadTimeDays"
          label={labels.leadTime}
          type="number"
          labelClassName="min-h-[40px] flex items-end pb-2"
        />
      </div>

      <div className="grid grid-cols-1 gap-6 pt-2 sm:grid-cols-2">
        <FormSelectField
          control={control}
          name="weightUnit"
          label={labels.salesUnitLabel}
          options={[
            { label: labels.saleUnitKg, value: "kg" },
            { label: labels.saleUnitLb, value: "lb" },
            { label: labels.saleUnitG, value: "g" },
          ]}
        />
        <FormInputField
          control={control}
          name="weight"
          type="number"
          label={labels.weightPerUnitLabel}
          placeholder="0.00"
          className="[&_input]:pr-16"
          rightElement={
            <div className="flex h-full w-16 items-center justify-between rounded-r-md border-l border-input bg-muted/50 px-3 text-sm font-medium text-muted-foreground">
              <span>{weightUnit || "kg"}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="h-3 w-3 opacity-50"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </div>
          }
        />
      </div>
    </div>
  )
}
